const states = (state = [], action) => {
    switch(action.type) {
        case 'SET_STATES':
            return action.payload;
            break;
        default: 
            return state;
            break;
    }
}

export default states;